import React from 'react';
import DOMPurify from "dompurify"; // XSS 공격을 방어하기 위한 라이브러리

function MessageConsultantFirst({ text }) {
  const sanitizedText = DOMPurify.sanitize(text);

  return (
    <div className="py-[10px] px-[14px] mb-2 bg-[#F0F3F7] rounded-xl rounded-tl-[4px]">
      <p className="text-[15px] whitespace-pre-line" dangerouslySetInnerHTML={{ __html: sanitizedText }}></p>
    </div>
  );
}

export default MessageConsultantFirst;